var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h2',[_vm._v("(404) Page NotFound")]),_c('p',[_c('span',{staticClass:"red--text"},[_vm._v("http://kompetencehuset"+_vm._s(_vm.url))]),_vm._v(" was not found ")])])}
var staticRenderFns = []

export { render, staticRenderFns }